<template>
  <nav class="main-nav scroll-invisible" ref="el">
    <RouterLink ref="funds" :to="{ name: FUNDS }">{{ $t('fanvestor.main-nav.funds') }}</RouterLink>
    <Separator />
    <RouterLink ref="clubs" :to="{ name: CLUBS }">{{ $t('fanvestor.main-nav.clubs') }}</RouterLink>
    <Separator v-if="authStore.user" />
    <RouterLink v-if="authStore.user" ref="portfolio" :to="{ name: PORTFOLIO }">{{
      $t('fanvestor.main-nav.portfolio')
    }}</RouterLink>
  </nav>
</template>
<script lang="ts" setup>
import { useScroll } from '@vueuse/core'
import { nextTick, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import Separator from '@/assets/images/main-nav-separator.svg?component'
import { useAuthStore } from '@/modules/auth/store'
import { CLUBS, FUNDS, PORTFOLIO } from '@/modules/fanvestor/routes'

const funds = ref<{ $el: HTMLElement }>()
const clubs = ref<{ $el: HTMLElement }>()
const portfolio = ref<{ $el: HTMLElement }>()
const el = ref<HTMLElement>()
const route = useRoute()
const authStore = useAuthStore()

const { x } = useScroll(el, { behavior: 'smooth' })

function centerActiveLink() {
  const links = [funds.value, clubs.value, portfolio.value]
  links.forEach((link) => {
    if (link && link.$el && link.$el.classList.contains('router-link-active')) {
      const width = el.value?.clientWidth || 100
      const offset = (width - link.$el.clientWidth) / 2
      x.value = link.$el.offsetLeft - offset
    }
  })
}

onMounted(() => {
  centerActiveLink()
})
watch(route, () => {
  nextTick(() => {
    centerActiveLink()
  })
})
</script>
<style scoped lang="postcss">
.main-nav {
  @apply flex items-center h-14 text-4xl font-extrabold italic flex-nowrap whitespace-nowrap gap-5 text-white-20 px-5 sm:!overflow-x-visible;
  * {
    @apply shrink-0;
  }

  & > a.router-link-active {
    @apply text-white hover:text-white;
  }
  & > a:hover {
    @apply text-white-60;
  }
}
</style>
